import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ManualRecordService {
  constructor(private http: HttpClient) {}

  createManualRecord(payload: any) {
    return this.http.post(`${environment.apiUrl}/manual-records`, payload);
  }

  getManualRecordById(id: string) {
    return this.http.get(`${environment.apiUrl}/manual-records/${id}`);
  }

  updateManualRecord(id: string, payload: any) {
    return this.http.put(`${environment.apiUrl}/manual-records/${id}`, payload);
  }

  archiveManualRecord(id: string) {
    return this.http.delete(`${environment.apiUrl}/manual-records/${id}`);
  }

  getPagedManualRecords(payload: any) {
    return this.http.post(
      `${environment.apiUrl}/manual-records/paged`,
      payload
    );
  }

  getManualRecordsByDateRange(payload:any) {
    return this.http.post(
      `${environment.apiUrl}/manual-records/get-by-date-range`,
      payload
    );
  }
}
